
import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { VendorsModule } from '@my-aon/vendors';

import { DialogTopComponent } from '../dialog-top/dialog-top.component';
import { DialogBottomComponent } from '../dialog-bottom/dialog-bottom.component';
import { FormContactUsComponent } from '../form-contact-us/form-contact-us.component';

@Component({
    selector: 'app-dialog-contact-us',

    templateUrl: './dialog-contact-us.component.html',
    styleUrl: './dialog-contact-us.component.scss',
     standalone: true,
    imports: [
        VendorsModule,
        DialogTopComponent,
        DialogBottomComponent,
        FormContactUsComponent
    ],
})
export class DialogContactUsComponent {
    
    readonly dialogRef = inject<MatDialogRef<DialogContactUsComponent>>(MatDialogRef);

    submited: boolean = false;

    close = (e: void): void => {
        this.dialogRef.close(e);
    };

    onSubmit = (e?: any): void => {
        if (this.submited === false) this.submited = true;
    };
}
